// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description-div {
  color: black;
  font-size: 20px;
  font-weight: 600;
}

.add-cart-btn-product {
  width: 70%;
  height: 40px;
  border-radius: 5px;
  border: none;
  background-color: #28af4b;
  color: white;
  font-family: Manrope;
}

.weight-inner-text-heading-four {
  color: #28af4b;
}
.buy-now-btn-product {
  color: white;
  border-radius: 0;
  background-image: linear-gradient(#28af4b, #0f6325);
}

.buy-now-btn-product:hover {
  background-image: linear-gradient(#0f6325, #28af4b);
  color: white;
}

.image-carousel-product {
  width: 600%;
  height: 300px;
  aspect-ratio: 2/1;
}

.right-product-div {
  justify-content: left;
  /* align-content: center; */
}

.fish-category-text {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: black;
}

.fish-details-text {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #333132;
}
.fish-details-text-cat {
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #333132;
}
.fish-details-text-gm {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #333132;
}

.fish-desc-text {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #333132;
}

.desc-text {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #333132;
}

/* .add-to-cart-button {
  background-color: white;
  color: #0f6325;
  border-radius: 4px;
  border: 1px solid #0f6325;
  padding: 2px 12px;
  font-family: Manrope;
  width: 100%;
  border: none;
} */

/* .add-to-cart-button:hover {
  background-color: #0f6325;
} */

.benifit-head-text {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #333132;
}

.benifit-sub-text {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #333132;
}

.cart-text {
  font-family: "Manrope", sans-serif;
  font-weight: 800;
  font-size: 14px;
  color: #333132;
}

.product-cart-box {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.fish-cart-box {
  border-radius: 10px;
}

.cart-fish-name {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #333132;
}

.cart-fish-weight {
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #333132;
}

.cart-fish-price {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #333132;
}

/* productdetails.css */

.product-details-container ul {
  display: flex;
  overflow-x: auto;
  flex-direction: column;
  scrollbar-width: none;
}

.product-details-container .nav-link.active,
.product-details-container .nav-link:focus,
.product-details-container .nav-link:hover {
  background-color: transparent !important;
  color: #28af4b !important;
}

.product-details-container .nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: 500;
  color: black;
  text-decoration: none;
  background: 0 0;
  border: 0;
  border-bottom-width: 3px;
  font-family: "Manrope", sans-serif;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}

.product-details-container .nav-link.active {
  position: relative;
  color: inherit;
}

.product-details-container .nav-link.active::after {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  /* top: 100%; */
  bottom: -10px;
  width: 100%;
  border-bottom: 4px solid #28af4b; /* Adjust the underline color */
}

.product-details-container .nav-item {
  margin-right: 35px;
}

.product-details-container .nav-tabs .nav-link:hover {
  isolation: isolate;
  border-color: white;
  border-bottom-width: 5px;
  position: relative;
  transition: border-bottom 0.5s ease;
}

.product-details-container .mb-3 {
  height: 50px;
}

.product-details-container .nav-tabs .nav-item.show .nav-link,
.product-details-container .nav-tabs .nav-link.active {
  border-color: white;
}

.product-details-container .nav-tabs .nav-link {
  border-top-left-radius: none;
  border-top-right-radius: none;
}

.product-details-container .nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: #d9d9d9;
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg)
    var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color)
    var(--bs-border-color) var(--bs-body-bg);
  border-bottom: 0.7px solid #eeeeee;
}

.icon-hover {
  animation: bounce 2.3s infinite ease-in 0.1s;
}

@keyframes bounce {
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.15);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.15);
  }

  70% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}
.recommended-container {
  display: inline-block;
}

.tab-container {
  font-family: "Manrope";
  font-weight: 700;
  font-size: 18px;
  color: #333132;
  line-height: 25px;
}
.image-container {
  min-height: 250px;
  align-content: center;
}
.additional-image-container {
  flex-direction: row;
  display: flex;
  /* justify-content: space-between; */
  width: 100%;
  overflow-x: scroll;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
}
.image-thumb-product {
  scroll-snap-align: center;
}
.tab-text {
  font-family: "Manrope";
  font-weight: 400;
  font-size: 16px;
  color: #333132;
  line-height: 33px;
}
/* .add-button-container {
  width: "20%";
  background-color: blue;
} */
.selected-tab-title {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #333132;
}

.react-multi-carousel-dot button {
  border-color: #28af4b;
}
.react-multi-carousel-dot--active button {
  background-color: #28af4b;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProductDetails/productdetails.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;;;;;GASG;;AAEH;;GAEG;;AAEH;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kEAAkE;EAClE,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,wBAAwB;EACxB,kCAAkC;EAClC;kCACgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,aAAa;EACb,WAAW;EACX,gCAAgC,EAAE,+BAA+B;AACnE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;EACnC,oDAAoD;EACpD;iDAC+C;EAC/C,yDAAyD;EACzD,+CAA+C;EAC/C;4CAC0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;;;GAGG;AACH;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".description-div {\n  color: black;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.add-cart-btn-product {\n  width: 70%;\n  height: 40px;\n  border-radius: 5px;\n  border: none;\n  background-color: #28af4b;\n  color: white;\n  font-family: Manrope;\n}\n\n.weight-inner-text-heading-four {\n  color: #28af4b;\n}\n.buy-now-btn-product {\n  color: white;\n  border-radius: 0;\n  background-image: linear-gradient(#28af4b, #0f6325);\n}\n\n.buy-now-btn-product:hover {\n  background-image: linear-gradient(#0f6325, #28af4b);\n  color: white;\n}\n\n.image-carousel-product {\n  width: 600%;\n  height: 300px;\n  aspect-ratio: 2/1;\n}\n\n.right-product-div {\n  justify-content: left;\n  /* align-content: center; */\n}\n\n.fish-category-text {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  color: black;\n}\n\n.fish-details-text {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #333132;\n}\n.fish-details-text-cat {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #333132;\n}\n.fish-details-text-gm {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #333132;\n}\n\n.fish-desc-text {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #333132;\n}\n\n.desc-text {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #333132;\n}\n\n/* .add-to-cart-button {\n  background-color: white;\n  color: #0f6325;\n  border-radius: 4px;\n  border: 1px solid #0f6325;\n  padding: 2px 12px;\n  font-family: Manrope;\n  width: 100%;\n  border: none;\n} */\n\n/* .add-to-cart-button:hover {\n  background-color: #0f6325;\n} */\n\n.benifit-head-text {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  color: #333132;\n}\n\n.benifit-sub-text {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  color: #333132;\n}\n\n.cart-text {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 800;\n  font-size: 14px;\n  color: #333132;\n}\n\n.product-cart-box {\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n\n.fish-cart-box {\n  border-radius: 10px;\n}\n\n.cart-fish-name {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #333132;\n}\n\n.cart-fish-weight {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #333132;\n}\n\n.cart-fish-price {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  color: #333132;\n}\n\n/* productdetails.css */\n\n.product-details-container ul {\n  display: flex;\n  overflow-x: auto;\n  flex-direction: column;\n  scrollbar-width: none;\n}\n\n.product-details-container .nav-link.active,\n.product-details-container .nav-link:focus,\n.product-details-container .nav-link:hover {\n  background-color: transparent !important;\n  color: #28af4b !important;\n}\n\n.product-details-container .nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: 500;\n  color: black;\n  text-decoration: none;\n  background: 0 0;\n  border: 0;\n  border-bottom-width: 3px;\n  font-family: \"Manrope\", sans-serif;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out;\n}\n\n.product-details-container .nav-link.active {\n  position: relative;\n  color: inherit;\n}\n\n.product-details-container .nav-link.active::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: 0;\n  /* top: 100%; */\n  bottom: -10px;\n  width: 100%;\n  border-bottom: 4px solid #28af4b; /* Adjust the underline color */\n}\n\n.product-details-container .nav-item {\n  margin-right: 35px;\n}\n\n.product-details-container .nav-tabs .nav-link:hover {\n  isolation: isolate;\n  border-color: white;\n  border-bottom-width: 5px;\n  position: relative;\n  transition: border-bottom 0.5s ease;\n}\n\n.product-details-container .mb-3 {\n  height: 50px;\n}\n\n.product-details-container .nav-tabs .nav-item.show .nav-link,\n.product-details-container .nav-tabs .nav-link.active {\n  border-color: white;\n}\n\n.product-details-container .nav-tabs .nav-link {\n  border-top-left-radius: none;\n  border-top-right-radius: none;\n}\n\n.product-details-container .nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: #d9d9d9;\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg)\n    var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color)\n    var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: 0.7px solid #eeeeee;\n}\n\n.icon-hover {\n  animation: bounce 2.3s infinite ease-in 0.1s;\n}\n\n@keyframes bounce {\n  0% {\n    transform: scale(1);\n  }\n\n  14% {\n    transform: scale(1.15);\n  }\n\n  28% {\n    transform: scale(1);\n  }\n\n  42% {\n    transform: scale(1.15);\n  }\n\n  70% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.recommended-container {\n  display: inline-block;\n}\n\n.tab-container {\n  font-family: \"Manrope\";\n  font-weight: 700;\n  font-size: 18px;\n  color: #333132;\n  line-height: 25px;\n}\n.image-container {\n  min-height: 250px;\n  align-content: center;\n}\n.additional-image-container {\n  flex-direction: row;\n  display: flex;\n  /* justify-content: space-between; */\n  width: 100%;\n  overflow-x: scroll;\n  scrollbar-width: none;\n  scroll-snap-type: x mandatory;\n}\n.image-thumb-product {\n  scroll-snap-align: center;\n}\n.tab-text {\n  font-family: \"Manrope\";\n  font-weight: 400;\n  font-size: 16px;\n  color: #333132;\n  line-height: 33px;\n}\n/* .add-button-container {\n  width: \"20%\";\n  background-color: blue;\n} */\n.selected-tab-title {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  color: #333132;\n}\n\n.react-multi-carousel-dot button {\n  border-color: #28af4b;\n}\n.react-multi-carousel-dot--active button {\n  background-color: #28af4b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
